import React from "react";
import "./TabContentPartnerUsers.scss";
import {
  Loader,
  LoaderSizes,
  Button,
  Iconography,
  IconographySizes,
  Pagination,
} from "@hid-galaxy-ui/galaxy-react";
import { useNavigate } from "react-router";
import { useAppSelector, useAppDispatch } from "../../../../../redux";
import PartnerUserFormModal from "../../../../../common/components/PartnerUserFormModal";
import { UserListType } from "../../../../../redux/slices/user/Types";
import PartnerUserCard from "../../../../../common/components/PartnerUserCard";

const TabContentPartnerUsers = () => {
  const [currentPageNumber, setCurrentPageNumber] = React.useState<number>(1);
  const [updateModalOpen, setUpdateModalOpen] = React.useState<boolean>(false);
  const [selectedUser, setSelectedUser] = React.useState<any | null>(null);
  const { userList, status } = useAppSelector((state) => state.user);
  const navigate = useNavigate();

  const handlePageChange = (clickedPageNumber: number | null) => {
    setCurrentPageNumber(clickedPageNumber);
  };

  const pageSize = 6;
  const totalRecords = userList.length;

  const paginatedData = userList.slice(
    (currentPageNumber - 1) * pageSize,
    currentPageNumber * pageSize
  );

  const onEditUserClick = (user: UserListType[0]) => {
    setSelectedUser(user);
    setUpdateModalOpen(true);
  };

  return (
    <div className="tab-content-partner-users-container">
      {status.userListLoading && userList.length === 0 ? (
        <div className="loading">
          <Loader variant={LoaderSizes.large} />
        </div>
      ) : userList.length > 0 ? (
        <div className="user-list-container">
          <div className="user-list-wrapper">
            {paginatedData.map((user) => {
              return (
                <PartnerUserCard
                  user={user}
                  onEditUserClick={onEditUserClick}
                  key={user.ID}
                />
              );
            })}
          </div>
          <Pagination
            currentPageNumber={currentPageNumber}
            totalRecords={totalRecords}
            pageSize={pageSize}
            border={true}
            onPageNumberClick={handlePageChange}
          />
        </div>
      ) : (
        <div className="no-partner-users">
          <Iconography icon="file" size={IconographySizes.Large} />
          <p>No Users Added For Partner</p>
        </div>
      )}
      {updateModalOpen && (
        <PartnerUserFormModal
          user={selectedUser}
          setModalOpen={setUpdateModalOpen}
          mode="Update"
        />
      )}
    </div>
  );
};

export default TabContentPartnerUsers;
